<template>
    <div v-for="user in users" :key="user">
        hola
        <li data-size="{{ $use.DatosPersonales.tipo_socio ??'Activo'}}">
        <div class="uk-card uk-card-default">
        <div class="uk-card-header">
        <div class="uk-grid-small uk-flex-middle" uk-grid>
        <div class="uk-width-auto">
        <img class="uk-border-circle" width="40" height="40" src="images/svg/mbqm.svg'}}">
        </div>
        <div class="uk-width-expand">
        <h4 class=" uk-margin-remove-bottom">{{user.nombre}} {{user.apellido}}</h4>
        <p class="uk-text-meta uk-margin-remove-top"><time datetime="2016-04-01T19:00"></time></p>
        </div>
        </div>
        </div>
        <a class="uk-card-footer" href="#modal-example" uk-toggle onclick="getUser({{user.id}})"> + Info</a>
        </div>
        </li>
    </div>
</template>
<script>
  export default {
    props: ['users'],
  }
</script>